import React from "react";
import axios from "axios";
import Table from "../assets/table";
import { Container, TextField } from "@material-ui/core";

class Database extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      password: ""
    };
  }

  componentDidMount = async () => {
    const doc = await axios.get("/api/hearingtest/data");
    this.setState({ rows: doc.data });
  };

  handleDelete = async (id) => {
    await axios.delete("/api/hearingtest/data/" + id);
    this.componentDidMount();
  };

  render() {
    const { rows, password } = this.state;

    return rows.length === 0 ? null : (
      <Container style={{ marginTop: "10%" }}>
        {
          password === "thisisthepassword"?
          <Table rows={rows} handleDelete={this.handleDelete} />
          :
          <TextField label="password" value={password} onChange={(e) => this.setState({password: e.target.value})}/>
        }
        
      </Container>
    );
  }
}

export default Database;
